import React, { useEffect, useState } from 'react';
import { consumeCode, clearLoginAttemptInfo } from 'supertokens-web-js/recipe/passwordless';
import { EPaths } from '@v2/constants/EPaths';
import { AuthProvider } from '@/auth/AuthProvider';

/**
 * This page is called when the user clicks on the magic link sent to them.
 */
export const PasswordlessVerifyPage: React.FC = () => {
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        async function handleMagicLinkClicked() {
            try {
                setLoading(true);
                // this calls the consumeCode API of the passwordless recipe
                // and verifies the code that was sent to the user in the magic link
                const response = await consumeCode();

                const searchParams = new URLSearchParams(window.location.search);
                const email = searchParams.get('email');
                const redirectPath = searchParams.get('redirect') || '/';
                const customerId = searchParams.get('customer_id');

                console.log('Magic link clicked:', email, redirectPath);

                if (response.status === 'OK') {
                    // we clear the login attempt info that was added when the createCode function
                    // was called since the login was successful.
                    await clearLoginAttemptInfo();

                    await AuthProvider.getInstance().me(response.user.emails[0], customerId);

                    // Handle redirect after successful login
                    window.location.assign(redirectPath);
                } else {
                    // this can happen if the magic link has expired or is invalid
                    // or if it was denied due to security reasons in case of automatic account linking

                    // we clear the login attempt info that was added when the createCode function
                    // was called - so that if the user does a page reload, they will now see the
                    // enter email / phone UI again.

                    await clearLoginAttemptInfo();
                    throw Error('Login failed. Please try again');
                    // window.location.assign('/auth');
                }
            } catch (err) {
                if (err.isSuperTokensGeneralError === true) {
                    // this may be a custom error message sent from the API by you.
                    console.error(err.message);
                } else {
                    console.error(err);
                }

                // Redirect to a screen to show error message and request a new magic link
                const searchParams = new URLSearchParams(window.location.search);
                // Encode the email and preserve the `+` character for aliases
                const email = searchParams.get('email');
                const encodedEmail = encodeURIComponent(email);

                const redirectPath = searchParams.get('redirect') || encodeURIComponent('/');
                const customerId = searchParams.get('customer_id') || '';
                window.location.assign(`${EPaths.MAGIC_LINK_REQUEST}?email=${encodedEmail}&return_path=${redirectPath}&customer_id=${customerId}`);
            } finally {
                await clearLoginAttemptInfo();
                setLoading(false);
            }
        }
        handleMagicLinkClicked();
    }, []);

    if (loading) {
        return <div>Verifying...</div>;
    }

    return <div>Verification successful! Redirecting...</div>;
};
